import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.NotFound.title',
    defaultMessage: 'Page Not Found',
  },
  url: {
    id: 'components.NotFound.url',
    defaultMessage: `https://voicearchive.com`,
  },
  email: {
    id: 'components.NotFound.email',
    defaultMessage: 'mail@voicearchive.com',
  },
  phone_number: {
    id: 'components.NotFound.phone_number',
    defaultMessage: '+45 7022 7042',
  },
  errorMessage: {
    id: 'components.NotFound.errorMessage',
    defaultMessage: `
          <h1>Oops! The page you were looking for could not be found.</h1>
          <p>
            We are sorry, but it seems the address you entered is incorrect or the page no longer exists.
          </p>

          <p>
            If you believe this is an error, please contact us at <email_link>{email}</email_link>
            or call us at <phone_link>{phone_number}</phone_link> for assistance.
          </p>

          <p>
            You can return to our homepage to explore our offerings, learn more about our services,
            and find what you're looking for by following this <link_home_page> link </link_home_page>.
          </p>
          <p>
            <span>➔</span> <link_home_page>{url}</link_home_page>.
          </p>`,
  },
})